module.exports = __webpack_public_path__ + "img/logo-le-bon-panier-black.e5a2f3dc.svg";